import {EventsRoute} from "./routes/Events.js";
const routes = [EventsRoute];
export default routes;
